import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-pricing-curve-save-add-dialog',
  styleUrls: ['./pricing-curve-save-add-dialog.component.scss'],
  templateUrl: './pricing-curve-save-add-dialog.component.html',
})
export class PricingCurveSaveAddDialogComponent implements OnInit {
  message: string
  submessage: string
  confirmMessage: string
  cancelMessage: string
  disableCloseButton: boolean
  isSubmessageWarning: boolean

  constructor(
    public matDialogRef: MatDialogRef<PricingCurveSaveAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      message?: string
      submessage?: string
      isSubmessageWarning?: boolean
      confirmMessage?: string
      cancelMessage?: string
      disableCloseButton?: boolean
    },
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.message = this.data.message ?? ''
      this.submessage = this.data.submessage ?? ''
      this.confirmMessage = this.data.confirmMessage ?? 'Confirm'
      this.cancelMessage = this.data.cancelMessage ?? 'Cancel'
      this.disableCloseButton = this.data.disableCloseButton ?? false
      this.isSubmessageWarning = this.data.isSubmessageWarning ?? false
    }
  }

  onConfirm(): void {
    this.matDialogRef.close(true)
  }

  onCancel(): void {
    this.matDialogRef.close(false)
  }
}
